var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoadbalancer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.667H14C12.5999 16.667 11.8998 16.667 11.365 16.3945C10.8946 16.1548 10.5122 15.7724 10.2725 15.302C10 14.7672 10 14.0671 10 12.667V7.33366C10 5.93353 10 5.23346 10.2725 4.69868C10.5122 4.22828 10.8946 3.84583 11.365 3.60614C11.8998 3.33366 12.5999 3.33366 14 3.33366H14.1667M14.1667 16.667C14.1667 17.5875 14.9129 18.3337 15.8333 18.3337C16.7538 18.3337 17.5 17.5875 17.5 16.667C17.5 15.7465 16.7538 15.0003 15.8333 15.0003C14.9129 15.0003 14.1667 15.7465 14.1667 16.667ZM14.1667 3.33366C14.1667 4.25413 14.9129 5.00033 15.8333 5.00033C16.7538 5.00033 17.5 4.25413 17.5 3.33366C17.5 2.41318 16.7538 1.66699 15.8333 1.66699C14.9129 1.66699 14.1667 2.41318 14.1667 3.33366ZM5.83333 10.0003L14.1667 10.0003M5.83333 10.0003C5.83333 10.9208 5.08714 11.667 4.16667 11.667C3.24619 11.667 2.5 10.9208 2.5 10.0003C2.5 9.07985 3.24619 8.33366 4.16667 8.33366C5.08714 8.33366 5.83333 9.07985 5.83333 10.0003ZM14.1667 10.0003C14.1667 10.9208 14.9129 11.667 15.8333 11.667C16.7538 11.667 17.5 10.9208 17.5 10.0003C17.5 9.07985 16.7538 8.33366 15.8333 8.33366C14.9129 8.33366 14.1667 9.07985 14.1667 10.0003Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadbalancer);
export default __webpack_public_path__ + "static/media/loadbalancer.738c52135cc90166f747b0bade02fff5.svg";
export { ForwardRef as ReactComponent };